import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addInterpreter } from "slices/interpreterSlice";
import { interpreterSelector } from "slices/interpreterSlice";
import ErrorMessage from "components/common/ErrorMessage";
import { setError } from "slices/interpreterSlice";
import toast from "react-hot-toast";
import { updateInterpreter } from "slices/interpreterSlice";
import Api from "services/api";
import { CustomSwitch } from "components/common/Switch";
import { stateSelector } from "slices/stateSlice";
import { citySelector } from "slices/citySlice";
import { Select } from "components/common/Select";
import { fetchLanguages } from "slices/languageSlice";
import { fetchStates } from "slices/stateSlice";
import { fetchCountries } from "slices/countrySlice";
import { fetchTimezone } from "slices/timezoneSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import PhoneInput from "components/common/PhoneInput";
import { Switch } from "@mui/material";
import { RateInput } from "components/template/TemplateForm";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import { useNavigate } from "react-router-dom";
import FullPageLoader from "components/common/FullPageLoader";
import { usePermissions } from "layouts/Admin";
import InterpreterRateSection from "./InterpreterRateSection";
import { USA } from "constants/common";
import Swal from "sweetalert2";
import { fetchPreferredLanguagesList } from "slices/languageSlice";
import VerificationDocuments from "components/interpreter/VerificationDocuments";
const apiService = new Api();

const appendFormData = (formData, value, key) => {
  if (value instanceof File) {
    formData.append(key, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((entry, index) => appendFormData(formData, entry, `${key}[${index}]`));
    return;
  }

  if (value && typeof value === "object") {
    Object.entries(value).forEach(([childKey, childValue]) => {
      appendFormData(formData, childValue, key ? `${key}[${childKey}]` : childKey);
    });
    return;
  }

  if (value !== undefined && value !== null) {
    formData.append(key, typeof value === "boolean" ? (value ? "1" : "0") : value);
  }
};

const AddInterpreter = ({ item }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      rates: [],
      church_translation: true,
      normal_translation: true,
      temple_recommend: true,
      vendor_agreement_expiry: item?.vendor_agreement_expiry
        ? String(item.vendor_agreement_expiry).split(/[T ]/)[0]
        : "",
        translation_rates: [
          {
            id: Date.now(),
            language: [],
            church: {
              translation_rate: "",
              editing_rate: "",
              dtp_rate: "",
              review_rate: "",
              audio_recording_rate: "",
              transcription_rate: "",
            },
            normal: {
              translation_rate: "",
              editing_rate: "",
              dtp_rate: "",
              review_rate: "",
              audio_recording_rate: "",
              transcription_rate: "",
            },
          },
        ],
    }
  });
  const [rateLanguages, setRateLanguages] = useState([
    { id: Date.now() }
  ]);
  const { error, loader } = useSelector(interpreterSelector);
  const [status, setStatus] = useState(1);
  const { state: states } = useSelector(stateSelector);
  const { city: cities } = useSelector(citySelector);
  const [credentialsSend, setCredentialsSend] = useState(0);
  const [internalInterpreter, setInternalInterpreter] = useState(1);
  const [autoAssign, setAutoAssign] = useState(false);
  const [isCompany, setIsCompany] = useState(false);
  const [interpretationEnabled, setInterpretationEnabled] = useState(1);
  const [translationEnabled, setTranslationEnabled] = useState(1);
  const [allCountries, setAllCountries] = useState([]);
  const [allTimezone, setAllTimezone] = useState([]);
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: "",
  });
  const [allStates, setAllStates] = useState([]);
  const [filterCountries, setfilterCountries] = useState({
    label: "",
    value: "",
  });
  const [availableTimezones, setAvailableTimezones] = useState([]);
  const [filterTimezones, setFilterTimezones] = useState({
    label: "",
    value: "",
  });
  const [timezoneDisable, setTimezoneDisable] = useState(false);
  const [preferredLanguageState, setPreferredLanguageState] = useState(null);

  const country_name = filterCountries?.label || "";

  const country_id = filterCountries?.value || "";
  const state_id = watch("state_id") ?? item?.state_id;
  const city_name = watch("city_name");
  const showInterpretationRatesSection = interpretationEnabled === 1;
  const showTranslationRatesSection = translationEnabled === 1;
  const translationChurchEnabled = watch("church_translation") !== false;
  const translationNormalEnabled = watch("normal_translation") !== false;

  const generateRandomPassword = (length = 10) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const handleCredentialsToggle = async (e) => {
    const checked = e.target.checked;

    if (checked) {
      const result = await Swal.fire({
        title: t('interpreter.confirmSendCredentialsTitle'),
        text: t('interpreter.confirmSendCredentialsText'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t('interpreter.confirmYes'),
        cancelButtonText: t('interpreter.confirmNo'),
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      if (result.isConfirmed) {
        setCredentialsSend(1);
        // const randomPwd = generateRandomPassword(10);
        // setValue("password", randomPwd, { shouldValidate: true });
      } else {
        setCredentialsSend(0);
        // clearErrors("password")
        // setValue("password", '');
      }
    } else {
      setCredentialsSend(0);
      // clearErrors("password")
      // setValue("password", '');
    }
  };

  const handleSimpleToggle = (e) => {
    setCredentialsSend(e.target.checked ? 1 : 0);
  };


  const clearAll = () => {
    setValue("code", "");
    setValue("first_name", "");
    setValue("last_name", "");
    setValue("email", "");
    setValue("password", "");
    setValue("phone", "");
    setValue("secondary_number", "");
    setValue("secondary_email", "");
    setValue("zip_code", "");
    setAutoAssign(false);
    setIsCompany(false);
    setCredentialsSend(0);
    setInternalInterpreter(1);
    setValue("us_based", false);
    setValue("non_us_based", false);
    setValue("english_to_target", false);
    setValue("spanish_to_target", false);
    setValue("court_certified", false);
    setValue("medical_certified", false);
    setValue("legal_certified", false);
    setValue("language_ids", []);
    setStatus(1);
    setValue("normal_hour_start_time", "");
    setValue("normal_hour_end_time", "");
    setValue("after_hour_start_time", "");
    setValue("after_hour_end_time", "");
    setValue("grace_period", 0);
    setValue("general_opi_vri_normal_rate", "");
    setValue("general_opi_vri_normal_rate_time_unit", "hour");
    setValue("general_inperson_normal_rate", "");
    setValue("general_inperson_normal_rate_time_unit", "hour");
    setValue("general_opi_vri_after_rate", "");
    setValue("general_opi_vri_after_rate_time_unit", "hour");
    setValue("general_inperson_after_rate", "");
    setValue("general_inperson_after_rate_time_unit", "hour");
    setValue("general_opi_vri_normal_min", "");
    setValue("general_opi_vri_normal_min_time_unit", "hour");
    setValue("general_inperson_normal_min", "");
    setValue("general_inperson_normal_min_time_unit", "hour");
    setValue("general_opi_vri_after_min", "");
    setValue("general_opi_vri_after_min_time_unit", "hour");
    setValue("general_inperson_after_min", "");
    setValue("general_inperson_after_min_time_unit", "hour");
    setValue("court_opi_vri_normal_rate", "");
    setValue("court_opi_vri_normal_rate_time_unit", "hour");
    setValue("court_inperson_normal_rate", "");
    setValue("court_inperson_normal_rate_time_unit", "hour");
    setValue("court_opi_vri_after_rate", "");
    setValue("court_opi_vri_after_rate_time_unit", "hour");
    setValue("court_inperson_after_rate", "");
    setValue("court_inperson_after_rate_time_unit", "hour");
    setValue("court_opi_vri_normal_min", "");
    setValue("court_opi_vri_normal_min_time_unit", "hour");
    setValue("court_inperson_normal_min", "");
    setValue("court_inperson_normal_min_time_unit", "hour");
    setValue("court_opi_vri_after_min", "");
    setValue("court_opi_vri_after_min_time_unit", "hour");
    setValue("court_inperson_after_min", "");
    setValue("court_inperson_after_min_time_unit", "hour");
    setValue("medical_opi_vri_normal_rate", "");
    setValue("medical_opi_vri_normal_rate_time_unit", "hour");
    setValue("medical_inperson_normal_rate", "");
    setValue("medical_inperson_normal_rate_time_unit", "hour");
    setValue("medical_opi_vri_after_rate", "");
    setValue("medical_opi_vri_after_rate_time_unit", "hour");
    setValue("medical_inperson_after_rate", "");
    setValue("medical_inperson_after_rate_time_unit", "hour");
    setValue("medical_opi_vri_normal_min", "");
    setValue("medical_opi_vri_normal_min_time_unit", "hour");
    setValue("medical_inperson_normal_min", "");
    setValue("medical_inperson_normal_min_time_unit", "hour");
    setValue("medical_opi_vri_after_min", "");
    setValue("medical_opi_vri_after_min_time_unit", "hour");
    setValue("medical_inperson_after_min", "");
    setValue("medical_inperson_after_min_time_unit", "hour");

    setValue("legal_opi_vri_normal_rate", "");
    setValue("legal_opi_vri_normal_rate_time_unit", "hour");
    setValue("legal_inperson_normal_rate", "");
    setValue("legal_inperson_normal_rate_time_unit", "hour");
    setValue("legal_opi_vri_after_rate", "");
    setValue("legal_opi_vri_after_rate_time_unit", "hour");
    setValue("legal_inperson_after_rate", "");
    setValue("legal_inperson_after_rate_time_unit", "hour");
    setValue("legal_opi_vri_normal_min", "");
    setValue("legal_opi_vri_normal_min_time_unit", "hour");
    setValue("legal_inperson_normal_min", "");
    setValue("legal_inperson_normal_min_time_unit", "hour");
    setValue("legal_opi_vri_after_min", "");
    setValue("legal_opi_vri_after_min_time_unit", "hour");
    setValue("legal_inperson_after_min", "");
    setValue("legal_inperson_after_min_time_unit", "hour");
    setValue("country_id", "");
    setValue("state_id", "");
    setValue("city_name", "");
    setValue("village", "");
    setValue("municipality", "");
    setValue("timezone_id", "");
    setValue("preferred_language_id", "");
    setPreferredLanguageState(null);
    setInterpretationEnabled(1);
    setTranslationEnabled(1);
  };

  console.log("interpreteritem", item);

  useEffect(() => {
    setValue(
      "vendor_agreement_expiry",
      item?.vendor_agreement_expiry
        ? String(item.vendor_agreement_expiry).split(/[T ]/)[0]
        : ""
    );
    setValue("code", item?.code || "");
    setValue("first_name", item?.first_name || "");
    setValue("last_name", item?.last_name || "");
    setValue("address", item?.address || "");
    setValue("email", item?.user?.email || "");
    setValue("phone", item?.phone || "");
    setValue("secondary_number", item?.secondary_number || undefined);
    setValue("secondary_email", item?.secondary_email || undefined);
    setValue("country_id", item?.country_id);
    setValue("city_name", item?.city_name || "");
    setValue("village", item?.village || "");
    setValue("municipality", item?.municipality || "");
    setValue("zip_code", item?.zip_code || "");
    setValue("state_id", item?.state_id);
    setValue("timezone_id", item?.timezone_id || "");
    setValue("preferred_language_id", item?.user?.preferred_language?.id || item?.user?.preferred_language_id || "");
    setCredentialsSend(
      typeof item?.user?.credentials_send == "number"
        ? item?.user?.credentials_send
        : 0
    );
    setInternalInterpreter(
      typeof item?.user?.internal_interpreter == "number"
        ? item?.user?.internal_interpreter
        : 1
    );
    setAutoAssign(typeof item?.auto_assign == "number" ? item?.auto_assign : 0);
    setIsCompany(typeof item?.is_company == "number" ? item?.is_company : 0);

    setValue("us_based", item?.filters?.us_based == 1 ? true : false || false);
    setValue(
      "non_us_based",
      item?.filters?.non_us_based == 1 ? true : false || false
    );
    setValue(
      "english_to_target",
      item?.filters?.english_to_target == 1 ? true : false || false
    );
    setValue(
      "spanish_to_target",
      item?.filters?.spanish_to_target == 1 ? true : false || false
    );
    setValue(
      "court_certified",
      item?.filters?.court_certified == 1 ? true : false || false
    );
    setValue(
      "medical_certified",
      item?.filters?.medical_certified == 1 ? true : false || false
    );
    setValue(
      "legal_certified",
      item?.filters?.legal_certified == 1 ? true : false || false
    );

    if (item?.id) {
      setInterpretationEnabled(["interpreter", "both"].includes(item?.service_type) ? 1 : 0);
      setTranslationEnabled(["translator", "both"].includes(item?.service_type) ? 1 : 0);
    } else {
      setInterpretationEnabled(1);
      setTranslationEnabled(1);
    }

    const translationRatePayload = Array.isArray(item?.translation_rates)
      ? item.translation_rates
      : [];

    const grouped = new Map();
    translationRatePayload.forEach((r) => {
      const langs = (r.languages || [])
        .map((l) => ({
          value: l.language_id || l.language?.id,
          label: l.language?.name || "",
        }))
        .filter((l) => l.value !== undefined && l.value !== null);

      const category = (r.category || r.type || r.rate_type || r.name || "").toString().toLowerCase();
      const key = langs.length
        ? langs.map((l) => l.value).sort((a, b) => a - b).join(",")
        : "_no_lang";

      if (!grouped.has(key)) {
        grouped.set(key, {
          id: Date.now() + Math.random(),
          language: langs,
          church: {
            translation_rate: "",
            editing_rate: "",
            dtp_rate: "",
            review_rate: "",
            audio_recording_rate: "",
            transcription_rate: "",
          },
          normal: {
            translation_rate: "",
            editing_rate: "",
            dtp_rate: "",
            review_rate: "",
            audio_recording_rate: "",
            transcription_rate: "",
          },
        });
      }

      const block = grouped.get(key);

      if (category === "church") {
        block.church = {
          translation_rate: r.translation_rate ?? block.church.translation_rate,
          editing_rate: r.editing_rate ?? block.church.editing_rate,
          dtp_rate: r.dtp_rate ?? block.church.dtp_rate,
          review_rate: r.review_rate ?? block.church.review_rate,
          audio_recording_rate: r.audio_recording_rate ?? block.church.audio_recording_rate,
          transcription_rate: r.transcription_rate ?? block.church.transcription_rate,
        };
      }
      if (category === "normal") {
        block.normal = {
          translation_rate: r.translation_rate ?? block.normal.translation_rate,
          editing_rate: r.editing_rate ?? block.normal.editing_rate,
          dtp_rate: r.dtp_rate ?? block.normal.dtp_rate,
          review_rate: r.review_rate ?? block.normal.review_rate,
          audio_recording_rate: r.audio_recording_rate ?? block.normal.audio_recording_rate,
          transcription_rate: r.transcription_rate ?? block.normal.transcription_rate,
        };
      }
    });

    const mappedTranslationRates = [...grouped.values()];
    if (mappedTranslationRates.length === 0) {
      mappedTranslationRates.push({
        id: Date.now(),
        language: [],
        church: {
          translation_rate: "",
          editing_rate: "",
          dtp_rate: "",
          review_rate: "",
          audio_recording_rate: "",
          transcription_rate: "",
        },
        normal: {
          translation_rate: "",
          editing_rate: "",
          dtp_rate: "",
          review_rate: "",
          audio_recording_rate: "",
          transcription_rate: "",
        },
      });
    }

    setValue("translation_rates", mappedTranslationRates);

    const hasChurchRates = mappedTranslationRates.some((block) =>
      [
        block.church?.translation_rate,
        block.church?.editing_rate,
        block.church?.dtp_rate,
        block.church?.review_rate,
        block.church?.audio_recording_rate,
        block.church?.transcription_rate,
      ].some((v) => v !== "" && v !== null && v !== undefined)
    );

    const hasNormalRates = mappedTranslationRates.some((block) =>
      [
        block.normal?.translation_rate,
        block.normal?.editing_rate,
        block.normal?.dtp_rate,
        block.normal?.review_rate,
        block.normal?.audio_recording_rate,
        block.normal?.transcription_rate,
      ].some((v) => v !== "" && v !== null && v !== undefined)
    );

    // setValue("church_translation", item ? hasChurchRates : true);
    // setValue("normal_translation", item ? hasNormalRates : true);
    
    setValue(
      "church_translation",
      item ? (item?.filters?.church_translation == 1 ? true : false) : true
    );
    setValue(
      "normal_translation",
      item ? (item?.filters?.normal_translation == 1 ? true : false) : true
    );
    setValue(
      "temple_recommend",
      item ? (item?.filters?.temple_recommend == 1 ? true : false) : true
    );

    setValue(
      "language_ids",
      item?.languages?.map((language) => language.language_id) || []
    );
    setStatus(typeof item?.status == "number" ? item?.status : 1);

    if (!item?.interpreter_rates?.length) return;

    const common = item.interpreter_rates[0];

    setValue("normal_hour_start_time", common.normal_hour_start_time || "");
    setValue("normal_hour_end_time", common.normal_hour_end_time || "");
    setValue("after_hour_start_time", common.after_hour_start_time || "");
    setValue("after_hour_end_time", common.after_hour_end_time || "");
    setValue("grace_period", common.grace_period || 0);

    setValue("spanish_translation_rate", common.spanish_translation_rate || "");
    setValue("other_translation_rate", common.other_translation_rate || "");
    setValue("spanish_formatting_rate", common.spanish_formatting_rate || "");
    setValue("other_formatting_rate", common.other_formatting_rate || "");

    const rates = item.interpreter_rates.map(rate => ({
      id: rate.id,
      // language_ids: rate.language_id || [],
      language_ids: rate.languages?.map(lang => ({
        value: lang.id,
        label: lang.name
      })) || [],
      // General Rates
      general_opi_vri_normal_rate: rate.general_opi_vri_normal_rate || 0,
      general_opi_vri_after_rate: rate.general_opi_vri_after_rate || 0,
      general_opi_vri_normal_rate_time_unit: rate.general_opi_vri_normal_rate_time_unit || "hour",
      general_opi_vri_after_rate_time_unit: rate.general_opi_vri_after_rate_time_unit || "hour",
      general_opi_vri_normal_min: rate.general_opi_vri_normal_min || 0,
      general_opi_vri_after_min: rate.general_opi_vri_after_min || 0,
      general_opi_vri_normal_min_time_unit: rate.general_opi_vri_normal_min_time_unit || "hour",
      general_opi_vri_after_min_time_unit: rate.general_opi_vri_after_min_time_unit || "hour",
      general_inperson_normal_rate: rate.general_inperson_normal_rate || 0,
      general_inperson_after_rate: rate.general_inperson_after_rate || 0,
      general_inperson_normal_rate_time_unit: rate.general_inperson_normal_rate_time_unit || "hour",
      general_inperson_after_rate_time_unit: rate.general_inperson_after_rate_time_unit || "hour",
      general_inperson_normal_min: rate.general_inperson_normal_min || 0,
      general_inperson_after_min: rate.general_inperson_after_min || 0,
      general_inperson_normal_min_time_unit: rate.general_inperson_normal_min_time_unit || "hour",
      general_inperson_after_min_time_unit: rate.general_inperson_after_min_time_unit || "hour",
      // Court Rates
      court_opi_vri_normal_rate: rate.court_opi_vri_normal_rate || 0,
      court_opi_vri_after_rate: rate.court_opi_vri_after_rate || 0,
      court_opi_vri_normal_rate_time_unit: rate.court_opi_vri_normal_rate_time_unit || "hour",
      court_opi_vri_after_rate_time_unit: rate.court_opi_vri_after_rate_time_unit || "hour",
      court_opi_vri_normal_min: rate.court_opi_vri_normal_min || 0,
      court_opi_vri_after_min: rate.court_opi_vri_after_min || 0,
      court_opi_vri_normal_min_time_unit: rate.court_opi_vri_normal_min_time_unit || "hour",
      court_opi_vri_after_min_time_unit: rate.court_opi_vri_after_min_time_unit || "hour",
      court_inperson_normal_rate: rate.court_inperson_normal_rate || 0,
      court_inperson_after_rate: rate.court_inperson_after_rate || 0,
      court_inperson_normal_rate_time_unit: rate.court_inperson_normal_rate_time_unit || "hour",
      court_inperson_after_rate_time_unit: rate.court_inperson_after_rate_time_unit || "hour",
      court_inperson_normal_min: rate.court_inperson_normal_min || 0,
      court_inperson_after_min: rate.court_inperson_after_min || 0,
      court_inperson_normal_min_time_unit: rate.court_inperson_normal_min_time_unit || "hour",
      court_inperson_after_min_time_unit: rate.court_inperson_after_min_time_unit || "hour",

      // Medical Rates
      medical_opi_vri_normal_rate: rate.medical_opi_vri_normal_rate || 0,
      medical_opi_vri_after_rate: rate.medical_opi_vri_after_rate || 0,
      medical_opi_vri_normal_rate_time_unit: rate.medical_opi_vri_normal_rate_time_unit || "hour",
      medical_opi_vri_after_rate_time_unit: rate.medical_opi_vri_after_rate_time_unit || "hour",
      medical_opi_vri_normal_min: rate.medical_opi_vri_normal_min || 0,
      medical_opi_vri_after_min: rate.medical_opi_vri_after_min || 0,
      medical_opi_vri_normal_min_time_unit: rate.medical_opi_vri_normal_min_time_unit || "hour",
      medical_opi_vri_after_min_time_unit: rate.medical_opi_vri_after_min_time_unit || "hour",
      medical_inperson_normal_rate: rate.medical_inperson_normal_rate || 0,
      medical_inperson_after_rate: rate.medical_inperson_after_rate || 0,
      medical_inperson_normal_rate_time_unit: rate.medical_inperson_normal_rate_time_unit || "hour",
      medical_inperson_after_rate_time_unit: rate.medical_inperson_after_rate_time_unit || "hour",
      medical_inperson_normal_min: rate.medical_inperson_normal_min || 0,
      medical_inperson_after_min: rate.medical_inperson_after_min || 0,
      medical_inperson_normal_min_time_unit: rate.medical_inperson_normal_min_time_unit || "hour",
      medical_inperson_after_min_time_unit: rate.medical_inperson_after_min_time_unit || "hour",

      //Legal
      legal_opi_vri_normal_rate: rate.legal_opi_vri_normal_rate || 0,
      legal_opi_vri_after_rate: rate.legal_opi_vri_after_rate || 0,
      legal_opi_vri_normal_rate_time_unit: rate.legal_opi_vri_normal_rate_time_unit || "hour",
      legal_opi_vri_after_rate_time_unit: rate.legal_opi_vri_after_rate_time_unit || "hour",
      legal_opi_vri_normal_min: rate.legal_opi_vri_normal_min || 0,
      legal_opi_vri_after_min: rate.legal_opi_vri_after_min || 0,
      legal_opi_vri_normal_min_time_unit: rate.legal_opi_vri_normal_min_time_unit || "hour",
      legal_opi_vri_after_min_time_unit: rate.legal_opi_vri_after_min_time_unit || "hour",
      legal_inperson_normal_rate: rate.legal_inperson_normal_rate || 0,
      legal_inperson_after_rate: rate.legal_inperson_after_rate || 0,
      legal_inperson_normal_rate_time_unit: rate.legal_inperson_normal_rate_time_unit || "hour",
      legal_inperson_after_rate_time_unit: rate.legal_inperson_after_rate_time_unit || "hour",
      legal_inperson_normal_min: rate.legal_inperson_normal_min || 0,
      legal_inperson_after_min: rate.legal_inperson_after_min || 0,
      legal_inperson_normal_min_time_unit: rate.legal_inperson_normal_min_time_unit || "hour",
      legal_inperson_after_min_time_unit: rate.legal_inperson_after_min_time_unit || "hour",
    }));

    console.log('ratess', rates);

    setRateLanguages(rates.map(r => ({ id: Date.now() + Math.random() })));
    setValue("rates", rates);
    // setValue(
    //   "normal_hour_start_time",
    //   item?.interpreter_rates[0]?.normal_hour_start_time || ""
    // );
    // setValue(
    //   "normal_hour_end_time",
    //   item?.interpreter_rates[0]?.normal_hour_end_time || ""
    // );
    // setValue(
    //   "after_hour_start_time",
    //   item?.interpreter_rates[0]?.after_hour_start_time || ""
    // );
    // setValue(
    //   "after_hour_end_time",
    //   item?.interpreter_rates[0]?.after_hour_end_time || ""
    // );
    // setValue("grace_period", item?.interpreter_rates[0]?.grace_period || 0);
    // setValue(
    //   "general_opi_vri_normal_rate",
    //   item?.interpreter_rates?.general_opi_vri_normal_rate || 0
    // );
    // setValue(
    //   "general_opi_vri_normal_rate_time_unit",
    //   item?.interpreter_rates?.general_opi_vri_normal_rate_time_unit || "hour"
    // );
    // setValue(
    //   "general_inperson_normal_rate",
    //   item?.interpreter_rates?.general_inperson_normal_rate || 0
    // );
    // setValue(
    //   "general_inperson_normal_rate_time_unit",
    //   item?.interpreter_rates?.general_inperson_normal_rate_time_unit || "hour"
    // );
    // setValue(
    //   "general_opi_vri_after_rate",
    //   item?.interpreter_rates?.general_opi_vri_after_rate || 0
    // );
    // setValue(
    //   "general_opi_vri_after_rate_time_unit",
    //   item?.interpreter_rates?.general_opi_vri_after_rate_time_unit || "hour"
    // );
    // setValue(
    //   "general_inperson_after_rate",
    //   item?.interpreter_rates?.general_inperson_after_rate || 0
    // );
    // setValue(
    //   "general_inperson_after_rate_time_unit",
    //   item?.interpreter_rates?.general_inperson_after_rate_time_unit || "hour"
    // );
    // setValue(
    //   "general_opi_vri_normal_min",
    //   item?.interpreter_rates?.general_opi_vri_normal_min || 0
    // );
    // setValue(
    //   "general_opi_vri_normal_min_time_unit",
    //   item?.interpreter_rates?.general_opi_vri_normal_min_time_unit || "hour"
    // );
    // setValue(
    //   "general_inperson_normal_min",
    //   item?.interpreter_rates?.general_inperson_normal_min || 0
    // );
    // setValue(
    //   "general_inperson_normal_min_time_unit",
    //   item?.interpreter_rates?.general_inperson_normal_min_time_unit || "hour"
    // );
    // setValue(
    //   "general_opi_vri_after_min",
    //   item?.interpreter_rates?.general_opi_vri_after_min || 0
    // );
    // setValue(
    //   "general_opi_vri_after_min_time_unit",
    //   item?.interpreter_rates?.general_opi_vri_after_min_time_unit || "hour"
    // );
    // setValue(
    //   "general_inperson_after_min",
    //   item?.interpreter_rates?.general_inperson_after_min || 0
    // );
    // setValue(
    //   "general_inperson_after_min_time_unit",
    //   item?.interpreter_rates?.general_inperson_after_min_time_unit || "hour"
    // );
    // setValue(
    //   "court_opi_vri_normal_rate",
    //   item?.interpreter_rates?.court_opi_vri_normal_rate || 0
    // );
    // setValue(
    //   "court_opi_vri_normal_rate_time_unit",
    //   item?.interpreter_rates?.court_opi_vri_normal_rate_time_unit || "hour"
    // );
    // setValue(
    //   "court_inperson_normal_rate",
    //   item?.interpreter_rates?.court_inperson_normal_rate || 0
    // );
    // setValue(
    //   "court_inperson_normal_rate_time_unit",
    //   item?.interpreter_rates?.court_inperson_normal_rate_time_unit || "hour"
    // );
    // setValue(
    //   "court_opi_vri_after_rate",
    //   item?.interpreter_rates?.court_opi_vri_after_rate || 0
    // );
    // setValue(
    //   "court_opi_vri_after_rate_time_unit",
    //   item?.interpreter_rates?.court_opi_vri_after_rate_time_unit || "hour"
    // );
    // setValue(
    //   "court_inperson_after_rate",
    //   item?.interpreter_rates?.court_inperson_after_rate || 0
    // );
    // setValue(
    //   "court_inperson_after_rate_time_unit",
    //   item?.interpreter_rates?.court_inperson_after_rate_time_unit || "hour"
    // );
    // setValue(
    //   "court_opi_vri_normal_min",
    //   item?.interpreter_rates?.court_opi_vri_normal_min || 0
    // );
    // setValue(
    //   "court_opi_vri_normal_min_time_unit",
    //   item?.interpreter_rates?.court_opi_vri_normal_min_time_unit || "hour"
    // );
    // setValue(
    //   "court_inperson_normal_min",
    //   item?.interpreter_rates?.court_inperson_normal_min || 0
    // );
    // setValue(
    //   "court_inperson_normal_min_time_unit",
    //   item?.interpreter_rates?.court_inperson_normal_min_time_unit || "hour"
    // );
    // setValue(
    //   "court_opi_vri_after_min",
    //   item?.interpreter_rates?.court_opi_vri_after_min || 0
    // );
    // setValue(
    //   "court_opi_vri_after_min_time_unit",
    //   item?.interpreter_rates?.court_opi_vri_after_min_time_unit || "hour"
    // );
    // setValue(
    //   "court_inperson_after_min",
    //   item?.interpreter_rates?.court_inperson_after_min || 0
    // );
    // setValue(
    //   "court_inperson_after_min_time_unit",
    //   item?.interpreter_rates?.court_inperson_after_min_time_unit || "hour"
    // );
    // setValue(
    //   "medical_opi_vri_normal_rate",
    //   item?.interpreter_rates?.medical_opi_vri_normal_rate || 0
    // );
    // setValue(
    //   "medical_opi_vri_normal_rate_time_unit",
    //   item?.interpreter_rates?.medical_opi_vri_normal_rate_time_unit || "hour"
    // );
    // setValue(
    //   "medical_inperson_normal_rate",
    //   item?.interpreter_rates?.medical_inperson_normal_rate || 0
    // );
    // setValue(
    //   "medical_inperson_normal_rate_time_unit",
    //   item?.interpreter_rates?.medical_inperson_normal_rate_time_unit || "hour"
    // );
    // setValue(
    //   "medical_opi_vri_after_rate",
    //   item?.interpreter_rates?.medical_opi_vri_after_rate || 0
    // );
    // setValue(
    //   "medical_opi_vri_after_rate_time_unit",
    //   item?.interpreter_rates?.medical_opi_vri_after_rate_time_unit || "hour"
    // );
    // setValue(
    //   "medical_inperson_after_rate",
    //   item?.interpreter_rates?.medical_inperson_after_rate || 0
    // );
    // setValue(
    //   "medical_inperson_after_rate_time_unit",
    //   item?.interpreter_rates?.medical_inperson_after_rate_time_unit || "hour"
    // );
    // setValue(
    //   "medical_opi_vri_normal_min",
    //   item?.interpreter_rates?.medical_opi_vri_normal_min || 0
    // );
    // setValue(
    //   "medical_opi_vri_normal_min_time_unit",
    //   item?.interpreter_rates?.medical_opi_vri_normal_min_time_unit || "hour"
    // );
    // setValue(
    //   "medical_inperson_normal_min",
    //   item?.interpreter_rates?.medical_inperson_normal_min || 0
    // );
    // setValue(
    //   "medical_inperson_normal_min_time_unit",
    //   item?.interpreter_rates?.medical_inperson_normal_min_time_unit || "hour"
    // );
    // setValue(
    //   "medical_opi_vri_after_min",
    //   item?.interpreter_rates?.medical_opi_vri_after_min || 0
    // );
    // setValue(
    //   "medical_opi_vri_after_min_time_unit",
    //   item?.interpreter_rates?.medical_opi_vri_after_min_time_unit || "hour"
    // );
    // setValue(
    //   "medical_inperson_after_min",
    //   item?.interpreter_rates?.medical_inperson_after_min || 0
    // );
    // setValue(
    //   "medical_inperson_after_min_time_unit",
    //   item?.interpreter_rates?.medical_inperson_after_min_time_unit || "hour"
    // );
    // setValue(
    //   "spanish_translation_rate",
    //   item?.interpreter_rates[0]?.spanish_translation_rate || ""
    // );
    // setValue(
    //   "other_translation_rate",
    //   item?.interpreter_rates[0]?.other_translation_rate || ""
    // );
    // setValue(
    //   "spanish_formatting_rate",
    //   item?.interpreter_rates[0]?.spanish_formatting_rate || ""
    // );
    // setValue(
    //   "other_formatting_rate",
    //   item?.interpreter_rates[0]?.other_formatting_rate || ""
    // );
    setValue(
      "is_translator",
      isTranslator
    );
  }, [item]);

  useEffect(() => {
    // Set default values if not already set
    setValue("normal_hour_start_time", "08:00"); // 8 AM
    setValue("normal_hour_end_time", "21:00"); // 9 PM
  }, [setValue]);

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      clearAll();
      navigate(-1);
    } else {
      console.log("onSubmit", error);
      toast.error(message, {
        className: "errorToast",
      });
    }
  };

  const onSubmit = (data) => {
    console.log("data", data);
    dispatch(setError({}));

    if (!interpretationEnabled && !translationEnabled) {
      toast.error(t('interpreter.enableAtLeastOneService'), {
        className: "errorToast",
      });
      return;
    }

    const derivedServiceType = interpretationEnabled && translationEnabled
      ? "both"
      : interpretationEnabled
      ? "interpreter"
      : "translator";

    if (
      showTranslationRatesSection &&
      !translationChurchEnabled &&
      !translationNormalEnabled
    ) {
      toast.error(t('interpreter.enableAtLeastOneTranslationType'), { className: "errorToast" });
      return;
    }
    
    const translationRatesPayload = showTranslationRatesSection
      ? (data.translation_rates || [])
          .filter((block) => Array.isArray(block.language) && block.language.length > 0)
          .map((block) => {
            const out = { language_ids: block.language.map((l) => l.value) };
            if (translationChurchEnabled) {
              out.church = {
                translation_rate: block.church?.translation_rate ?? 0,
                editing_rate: block.church?.editing_rate ?? 0,
                dtp_rate: block.church?.dtp_rate ?? 0,
                review_rate: block.church?.review_rate ?? 0,
                audio_recording_rate: block.church?.audio_recording_rate ?? 0,
                transcription_rate: block.church?.transcription_rate ?? 0,
              };
            }
            if (translationNormalEnabled) {
              out.normal = {
                translation_rate: block.normal?.translation_rate ?? 0,
                editing_rate: block.normal?.editing_rate ?? 0,
                dtp_rate: block.normal?.dtp_rate ?? 0,
                review_rate: block.normal?.review_rate ?? 0,
                audio_recording_rate: block.normal?.audio_recording_rate ?? 0,
                transcription_rate: block.normal?.transcription_rate ?? 0,
              };
            }
            return out;
          })
      : [];

    data = {
      ...data,
      credentialsSend,
      internalInterpreter,
      autoAssign,
      isCompany,
      service_type: derivedServiceType,
      interpretation: interpretationEnabled ? 1 : 0,
      translation: translationEnabled ? 1 : 0,
      status,
      is_translator: isTranslator,
      translation_rates: translationRatesPayload,
      rates: data.rates.map(rate => ({
        ...rate,
        // ensure IDs are sent for edit
        id: rate.id || undefined,
      })),
    };
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => appendFormData(formData, value, key));
    if (item?.id) {
      dispatch(updateInterpreter(formData, item?.id, submitCallback));
    } else dispatch(addInterpreter(formData, submitCallback));
  };

  // #region Country dropdown

  useEffect(() => {
    dispatch(fetchCountries(1, { id: item?.country?.id }));
    if (item?.country?.name && item?.country?.id) {
      setfilterCountries({
        label: item?.country?.name || "",
        value: item?.country?.id || "",
      });
    } else {
      setfilterCountries(null);
    }
  }, [item?.country]);

  const filteredCountriesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchCountries(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );

    setAllCountries(result?.data);
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.state?.id }));
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        label: item?.state?.name || "",
        value: item?.state?.id || "",
      });
    } else {
      setfilterStates(null);
    }
  }, [item?.state]);

  const filteredStatesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchStates(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    setAllStates(result?.data);
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region City dropdown
  const [allCities, setAllCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState({
    label: "",
    value: "",
  });
  const filteredCities = React.useMemo(
    () =>
      allCities?.map((val) => {
        const object = {
          label: item?.city?.name || val.name,
          value: item?.city?.id || val.id,
        };
        return object;
      }),
    [allCities, item?.city]
  );

  const filteredStates = React.useMemo(() => {
    setAllCities(
      item?.state?.name != null
        ? states?.find((state) => state?.name == item?.state?.name)?.cities
        : []
    );
    return states?.map((item) => {
      const object = {
        label: item?.name,
        value: item?.id,
      };
      return object;
    });
  }, [states, item?.state?.name]);

  useEffect(() => {
    setSelectedCity(filteredCities);
  }, [filteredCities]);

  useEffect(() => {
    if (item?.city?.name && item?.city?.id) {
      setSelectedCity({
        label: item?.city?.name || "",
        value: item?.city?.id || "",
      });
    } else {
      setSelectedCity(null);
    }
  }, [item?.city]);

  //#endregion

  // #region Language dropdown
  const [languageState, setLanguageState] = useState(null);

  useEffect(() => {
    setLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
  }, [item?.languages]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((language) => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region Interpreter dropdown
  const [interpreterState, setInterpreterState] = useState(null);

  const filteredInterpretersLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const response = await Api.fetchInterpretersList(
      page,
      {
        pageLength: 20,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
        internal_interpreter: internalInterpreter,
        ...(item?.id && { interpreter_id: item?.id })
      }
    );
    return {
      options: response?.data?.data?.data?.map((interpreter) => ({
        value: interpreter.id,
        label: `${interpreter.first_name} ${interpreter.last_name}`,
      })) || [],
      hasMore: page !== response?.data?.data?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  useEffect(() => {
    if (item?.linked_interpreter) {
      setInterpreterState({
        label: `${item.linked_interpreter.first_name} ${item.linked_interpreter.last_name}`,
        value: item.linked_interpreter.id,
      });
      setValue("linked_interpreter_ids", item.linked_interpreter.id);
    } else {
      setInterpreterState(null);
      setValue("linked_interpreter_ids", null);
    }
  }, [item?.linked_interpreter]);
  

  // useEffect(() => {
  //   setInterpreterState(null);
  //   setValue("linked_interpreter_ids", null);
  // }, [internalInterpreter, setValue]);

  // #region Timezone dropdown

  useEffect(() => {
    const fetchAndSetTimezone = async () => {
      if (!country_name) {
        setAvailableTimezones([]);
        setFilterTimezones(null);
        setValue("timezone_id", "");
        setTimezoneDisable(false);
        return;
      }

      try {
        const response = await dispatch(
          fetchTimezone(1, { country_id, state_id }, true, true)
        );
        const timezones = response?.data || [];

        const tzOptions = timezones.map((tz) => ({
          value: tz.id,
          label: tz.display_name,
        }));

        setAvailableTimezones(tzOptions);

        // US selected, state also selected
        if (country_name === USA && state_id) {
          if (tzOptions.length === 1) {
            setFilterTimezones(tzOptions[0]);
            setValue("timezone_id", tzOptions[0].value);
            setTimezoneDisable(true);
          } else {
            setFilterTimezones(null);
            setValue("timezone_id", "");
            setTimezoneDisable(false);
          }
        }
        // US selected, no state selected
        else if (country_name === USA) {
          setFilterTimezones(null);
          setValue("timezone_id", "");
          setTimezoneDisable(false);
        }
        // Any other country
        else {
          if (tzOptions.length === 1) {
            setFilterTimezones(tzOptions[0]);
            setValue("timezone_id", tzOptions[0].value);
            setTimezoneDisable(true);
          } else {
            setFilterTimezones(null);
            setValue("timezone_id", "");
            setTimezoneDisable(false);
          }
        }
      } catch (error) {
        console.error("Timezone fetch error:", error);
        setAvailableTimezones([]);
        setFilterTimezones(null);
        setValue("timezone_id", "");
        setTimezoneDisable(false);
      }
    };

    fetchAndSetTimezone();
  }, [filterCountries, filterStates, setValue, dispatch]);

  // Load options function (API call to timezone endpoint)
  const filteredTimezonesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchTimezone(
        page,
        {
          pageLength: 10,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
          country_id,
          state_id,
        },
        true,
        true
      )
    );

    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.display_name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  //#endregion

  const handleChangeSwitch = (value, onChange) => {
    onChange(value);
  };


  const [isTranslator, setIsTranslator] = useState(
    item?.is_translator === 1 ? 1 : 0
  );

  useEffect(() => {
    setIsTranslator(showTranslationRatesSection ? 1 : 0);
  }, [showTranslationRatesSection]);

  useEffect(() => {
    if (item?.user?.preferred_language?.id) {
      setPreferredLanguageState({
        label: item?.user?.preferred_language?.name || "",
        value: item?.user?.preferred_language?.id || "",
      });
    } else {
      setPreferredLanguageState(null);
    }
  }, [item?.user?.preferred_language]);

  const filteredPreferredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchPreferredLanguagesList(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((language) => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <>
      <form className="card_table p-4" onSubmit={handleSubmit(onSubmit)}>
        <div className="template foam_page_row interpreter_form">
          {item?.id && (
            <div className="row-primary">
              <h2>{t('interpreter.vendorCode')} *</h2>
              <Controller
                name="code"
                control={control}
                render={({ field }) => (
                  <div className="w-100">
                    <input
                      className="input-in type_inp"
                      type="text"
                      name="code"
                      placeholder={t('interpreter.interpreterCode')}
                      readOnly
                      value={field.value}
                    />
                  </div>
                )}
              />
            </div>
          )}
          <div className="row-primary">
            <h2>{t('interpreter.firstName')} *</h2>
            <Controller
              name="first_name"
              rules={{
                required: t('interpreter.firstNameRequired'),
              }}
              control={control}
              render={({ field }) => (
                <div className="w-100">
                  <input
                    className="input-in type_inp"
                    type="text"
                    name="first-name"
                    placeholder={t('interpreter.firstNamePlaceholder')}
                    {...field}
                  />
                  {error?.errors?.first_name?.length > 0 &&
                    error?.errors?.first_name?.map((error) => (
                      <ErrorMessage text={error} />
                    ))}
                  {errors?.first_name?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.first_name?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2>{t('interpreter.lastName')}</h2>
            <Controller
              name="last_name"
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="text"
                  name="last-name"
                  placeholder={t('interpreter.lastNamePlaceholder')}
                  {...field}
                />
              )}
            />
          </div>

          <div className="row-primary">
            <h2>{t('interpreter.email')} *</h2>
            <Controller
              name="email"
              rules={{
                required: t('interpreter.emailRequired'),
              }}
              control={control}
              render={({ field }) => (
                <div className="w-100">
                  <input
                    className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""
                      } `}
                    type="email"
                    name="email"
                    pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
                    placeholder={t('interpreter.emailAddress')}
                    {...field}
                  />
                  {error?.errors?.email?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.email?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.email?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2>
              {t('interpreter.password')} {(!item || credentialsSend === 1) && "*"}
            </h2>
            <div className="w-100">
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <input
                    className={`input-in type_inp `}
                    autoComplete="off"
                    type="password"
                    name="password"
                    placeholder={t('interpreter.password')}
                    {...field}
                    disabled={watch("type") == "interpreter" ? true : false}
                  />
                )}
              />
              {error?.errors?.password?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
              {errors?.password?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.password?.message} />
                </div>
              )}
            </div>
          </div>

          <div className="row-primary">
            <h2>{t('interpreter.phoneNumber')} *</h2>

            <Controller
              name="phone"
              control={control}
              rules={{
                required: t('interpreter.phoneNumberRequired'),
              }}
              render={({ field }) => (
                <div className="w-100">
                  <PhoneInput
                    className="input-in type_inp"
                    type="tel"
                    name="phone"
                    placeholder={t('interpreter.phoneNumberPlaceholder')}
                    {...field}
                  />
                  {error?.errors?.phone?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.phone?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.phone?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2>{t('interpreter.secondaryEmail')}</h2>
            <Controller
              name="secondary_email"
              control={control}
              render={({ field }) => (
                <input
                  className={`input-in type_inp ${error?.errors?.secondary_email ? "border-red" : ""
                    } `}
                  type="text"
                  name="secondary_email"
                  placeholder={t('interpreter.secondaryEmailPlaceholder')}
                  {...field}
                />
              )}
            />
          </div>

          <div className="row-primary">
            <h2>{t('interpreter.secondaryNumber')}</h2>
            <Controller
              name="secondary_number"
              control={control}
              render={({ field }) => (
                <PhoneInput
                  className="input-in type_inp"
                  type="tel"
                  name="phone"
                  placeholder={t('interpreter.phoneNumberPlaceholder')}
                  {...field}
                />
              )}
            />
          </div>

          <div className="row-primary">
            <h2>{t('interpreter.selectCountry')} *</h2>

            <Controller
              name="country_id"
              control={control}
              rules={{
                required: t('interpreter.countryRequired'),
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={selectCustomStyles}
                    value={filterCountries}
                    loadOptions={filteredCountriesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(obj) => {
                      setfilterCountries(obj);
                      field.onChange(obj?.value);
                      if (obj?.label != USA) {
                        setValue("state_id", "");
                        setValue("zip_code", "");
                      }
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                  {errors?.country_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.country_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>
          {/* {country_name && country_name == USA && (
            <> */}
              <div className="row-primary">
                <h2>{t('interpreter.selectState')}</h2>

                <Controller
                  name="state_id"
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={selectCustomStyles}
                        value={filterStates}
                        loadOptions={filteredStatesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          setfilterStates(obj);
                          setAllCities(
                            obj != null
                              ? allStates?.find(
                                (states) => states?.name == obj?.label
                              )?.cities
                              : []
                          );
                          field.onChange(obj?.value);
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                      {errors?.state_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.state_id?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              {country_name && country_name != USA && (
                <>
                  <div className="row-primary">
                    <h2>{t('interpreter.municipality')}</h2>

                    <Controller
                      name="municipality"
                      control={control}
                      render={({ field }) => (
                        <div className="w-100">
                          <input
                            className="input-in type_inp"
                            type="text"
                            name="municipality"
                            placeholder={t('interpreter.enterMunicipality')}
                            {...field}
                          />
                          {errors?.municipality?.message && (
                            <div style={{ marginBottom: 10 }}>
                              <ErrorMessage text={errors?.municipality?.message} />
                            </div>
                          )}
                        </div>
                      )}
                    />
                  </div>

                  <div className="row-primary">
                    <h2>{t('interpreter.village')}</h2>

                    <Controller
                      name="village"
                      control={control}
                      render={({ field }) => (
                        <div className="w-100">
                          <input
                            className="input-in type_inp"
                            type="text"
                            name="village"
                            placeholder={t('interpreter.enterVillage')}
                            {...field}
                          />
                          {errors?.village?.message && (
                            <div style={{ marginBottom: 10 }}>
                              <ErrorMessage text={errors?.village?.message} />
                            </div>
                          )}
                        </div>
                      )}
                    />
                  </div>
                </>
              )}


              <div className="row-primary">
                <h2>{t('interpreter.cityName')}</h2>

                <Controller
                  name="city_name"
                  control={control}
                  render={({ field }) => (
                    <div className="w-100">
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="city_name"
                        placeholder={t('interpreter.enterCityName')}
                        {...field}
                      />
                      {errors?.city_name?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.city_name?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              {country_name && country_name != USA && (
                <div className="row-primary">
                  <h2>{t('interpreter.address')}</h2>
                  <Controller
                    name="address"
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="address"
                        placeholder={t('interpreter.addressPlaceholder')}
                        {...field}
                      />
                    )}
                  />
                </div>
              )}

              <div className="row-primary">
                <h2>{t('interpreter.zipCode')}</h2>
                <Controller
                  name="zip_code"
                  control={control}
                  render={({ field }) => (
                    <div className="w-100">
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="zip_code"
                        placeholder={t('interpreter.zipCodePlaceholder')}
                        {...field}
                      />
                      {errors?.zip_code?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.zip_code?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
            {/* </>
          )} */}

          <div className="row-primary">
            <h2>{t('interpreter.timezone')}</h2>
            <Controller
              name="timezone_id"
              control={control}
              rules={{ required: t('interpreter.timezoneRequired') }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    key={`timezone_${country_id}_${state_id}`}
                    styles={selectCustomStyles}
                    value={filterTimezones}
                    loadOptions={filteredTimezonesLoadOptions}
                    isClearable
                    placeholder={t('interpreter.selectTimezone')}
                    onChange={(selected) => {
                      setFilterTimezones(selected);
                      setValue("timezone_id", selected?.value || "");
                      field.onChange(selected?.value || "");
                    }}
                    additional={{ page: 1 }}
                  />
                  {errors?.timezone_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.timezone_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>


          <div className="row-primary">
            <h2>{t('interpreter.selectLanguages')} *</h2>
            <Controller
              name="language_ids"
              required
              rules={{
                required: t('interpreter.languagesRequired'),
              }}
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      isMulti
                      styles={{
                        ...selectCustomStyles,
                      }}
                      value={languageState}
                      loadOptions={filteredLanguagesLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(selected) => {
                        setLanguageState(selected);
                        field.onChange(selected.map((opt) => opt.value));
                      }}
                      additional={{
                        page: 1,
                      }}
                    />
                  </div>
                  {errors?.language_ids?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.language_ids?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          {/* <div className="row-primary">
            <h2>Link with Interpreter</h2>
            <Controller
              name="linked_interpreter_ids"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      key={`interpreter_${internalInterpreter}_${Date.now()}`}
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      value={interpreterState}
                      loadOptions={filteredInterpretersLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(selected) => {
                        setInterpreterState(selected);
                        field.onChange(selected ? selected.value : null);
                      }}
                      additional={{ page: 1 }}
                    />
                  </div>
                </div>
              )}
            />
          </div> */}

          <div className="row-primary">
            <h2>{t('interpreter.preferredLanguage')} *</h2>
            <div className="w-100">
              <Controller
                name="preferred_language_id"
                control={control}
                rules={{ required: t('interpreter.preferredLanguageRequired') }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      value={preferredLanguageState}
                      loadOptions={filteredPreferredLanguagesLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(selected) => {
                        setPreferredLanguageState(selected || null);
                        setValue("preferred_language_id", selected?.value || "");
                        field.onChange(selected?.value || "");
                      }}
                      placeholder={t('interpreter.selectLanguage')}
                      additional={{ page: 1 }}
                    />
                    {errors?.preferred_language_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.preferred_language_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>

          <div className="row-primary align-items-center template_switch">
            <h2 className="m-0">{t('interpreter.credentialsWillBeSent')}</h2>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="credentials_send"
                checked={credentialsSend === 1 ? true : false}
                onChange={item ? handleCredentialsToggle : handleSimpleToggle}
              />
              <span className="checkmark"></span>
            </label>
          </div>


          {/* <div className="row-primary align-items-center template_switch">
            <h2 className="m-0">Staff Interpreter</h2>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="internal_interpreter"
                checked={internalInterpreter === 1 ? true : false}
                onChange={(e) => setInternalInterpreter(e.target.checked ? 1 : 0)}
              />
              <span className="checkmark"></span>
            </label>
          </div> */}

          
          <div className="row-primary" style={{ width: "100%" }}>

            <div className="row-primary">
              <h2>{t('interpreter.linkWithVendor')}</h2>
              <Controller
                name="linked_interpreter_ids"
                control={control}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        key={`interpreter_${internalInterpreter}_${Date.now()}`}
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={interpreterState}
                        loadOptions={filteredInterpretersLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(selected) => {
                          setInterpreterState(selected);
                          field.onChange(selected ? selected.value : null);
                        }}
                        additional={{ page: 1 }}
                      />
                    </div>
                  </div>
                )}
              />
            </div>

            <div className="row-primary align-items-center template_switch">
            <h2 className="m-0">{t('interpreter.staffVendor')}</h2>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="internal_interpreter"
                checked={internalInterpreter === 1 ? true : false}
                onChange={(e) => setInternalInterpreter(e.target.checked ? 1 : 0)}
              />
              <span className="checkmark"></span>
            </label>
            </div>
          </div>


          <div className="row-primary" style={{ width: "100%" }}>
          <div className="row-primary align-items-center template_switch">
            <h2 className="mt-0">{t('interpreter.autoAssign')}</h2>
            <CustomSwitch
              labelText="auto_assign"
              checked={autoAssign == 1 ? true : false}
              handleChange={(checked) => setAutoAssign(checked ? 1 : 0)}
            />
          </div>

          <div className="row-primary align-items-center template_switch">
            <h2 className="mt-0">{t('interpreter.company')}</h2>
            <CustomSwitch
              labelText="auto_assign"
              checked={isCompany == 1 ? true : false}
              handleChange={(checked) => setIsCompany(checked ? 1 : 0)}
            />
          </div>
          </div>
        </div>

        <div className="row-primary row-r justify-content-between flex-row">
          <h2 className="fst-italic">{t('interpreter.vendorServiceType')}</h2>
        </div>
        <div className="template foam_page_row interpreter_form">
          <div className="row-primary w-100">
            <div className="row-primary align-items-center template_switch">
              <h2 className="mt-0">{t('invoice.interpretation')}</h2>
              <CustomSwitch
                labelText="interpretation_enabled"
                checked={interpretationEnabled == 1 ? true : false}
                handleChange={(checked) => setInterpretationEnabled(checked ? 1 : 0)}
              />
            </div>
            <div className="row-primary align-items-center template_switch">
              <h2 className="mt-0">{t('invoiceEditForm.translation')}</h2>
              <CustomSwitch
                labelText="translation_enabled"
                checked={translationEnabled == 1 ? true : false}
                handleChange={(checked) => setTranslationEnabled(checked ? 1 : 0)}
              />
            </div>
          </div>
        </div>

        {/* filter area  */}
        <div className="row-primary row-r justify-content-between flex-row">
          <h2 className="fst-italic">{t('interpreter.filters')}</h2>
        </div>
        <div className="Filter_wrapper">
          {showInterpretationRatesSection && (
            <>
            
          <div className="row-primary">
            <h2 className="col-6">{t('interpreter.usBasedVendor')}</h2>
            <Controller
              name="us_based"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">{t('interpreter.nonUsBasedVendor')}</h2>
            <Controller
              name="non_us_based"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">{t('interpreter.englishToTarget')}</h2>
            <Controller
              name="english_to_target"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">{t('interpreter.spanishToTarget')}</h2>
            <Controller
              name="spanish_to_target"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">{t('interpreter.courtCertified')}</h2>
            <Controller
              name="court_certified"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">{t('interpreter.medicalCertified')}</h2>
            <Controller
              name="medical_certified"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>
          </>
          )}

          {showTranslationRatesSection && (
            <>
              <div className="row-primary">
                <h2 className="col-6">{t('interpreter.churchTranslation')}</h2>
                <Controller
                  name="church_translation"
                  control={control}
                  render={({ field }) => (
                    <div className="switch_row">
                      <Switch
                        checked={field.value !== false}
                        onChange={(e) =>
                          handleChangeSwitch(e.target.checked, field.onChange)
                        }
                        value={true}
                      />
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2 className="col-6">{t('interpreter.normalTranslation')}</h2>
                <Controller
                  name="normal_translation"
                  control={control}
                  render={({ field }) => (
                    <div className="switch_row">
                      <Switch
                        checked={field.value !== false}
                        onChange={(e) =>
                          handleChangeSwitch(e.target.checked, field.onChange)
                        }
                        value={true}
                      />
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2 className="col-6">{t('interpreter.templeRecommend')}</h2>
                <Controller
                  name="temple_recommend"
                  control={control}
                  render={({ field }) => (
                    <div className="switch_row">
                      <Switch
                        checked={field.value !== false}
                        onChange={(e) =>
                          handleChangeSwitch(e.target.checked, field.onChange)
                        }
                        value={true}
                      />
                    </div>
                  )}
                />
              </div>
            </>
          )}
        </div>

        {/* filter area  */}

        {showInterpretationRatesSection && (
        <InterpreterRateSection
          control={control}
          errors={errors}
          watch={watch}
          setValue={setValue}
          ErrorMessage={ErrorMessage}
        />
        )}

        <hr />

        
        {showTranslationRatesSection && (
          <div
            className="row-primary"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              marginTop: 20,
              marginBottom: 30,
            }}
          >
            <h2 className="fst-italic fw-bold mt-0">{t('interpreter.translationRates')}</h2>

            {/* Helpers for language exclusion */}
            {(function prepareHelpers() {
              const getAllSelectedLanguageIdsExceptCurrent = (currentIndex) => {
                const blocks = watch("translation_rates") || [];
                return blocks
                  .filter((_, idx) => idx !== currentIndex)
                  .flatMap((b) =>
                    Array.isArray(b.language)
                      ? b.language.map((l) => l.value)
                      : []
                  )
                  .filter((v) => v !== null && v !== undefined);
              };

              const filteredLanguagesLoadOptions = (currentIndex) => async (
                inputValue,
                loadedOptions,
                { page }
              ) => {
                const result = await dispatch(
                  fetchLanguages(
                    page,
                    {
                      pageLength: 20,
                      sortBy: "id",
                      sortDirection: "asc",
                      search: inputValue,
                    },
                    true,
                    true
                  )
                );

                const selectedLanguageIds = getAllSelectedLanguageIdsExceptCurrent(currentIndex);

                return {
                  options: result?.data
                    ?.filter((lang) => !selectedLanguageIds.includes(lang.id))
                    .map((language) => ({
                      value: language.id,
                      label: language.name,
                    })),
                  hasMore: page !== result?.last_page,
                  additional: {
                    page: page + 1,
                  },
                };
              };

              const addMoreLanguageRate = () => {
                setValue("translation_rates", [
                  ...(watch("translation_rates") || []),
                  {
                    id: Date.now(),
                    language: [],
                    church: {
                      translation_rate: "",
                      editing_rate: "",
                      dtp_rate: "",
                      review_rate: "",
                      audio_recording_rate: "",
                      transcription_rate: "",
                    },
                    normal: {
                      translation_rate: "",
                      editing_rate: "",
                      dtp_rate: "",
                      review_rate: "",
                      audio_recording_rate: "",
                      transcription_rate: "",
                    },
                  },
                ]);
              };

              const removeLanguageRate = (id) => {
                setValue(
                  "translation_rates",
                  (watch("translation_rates") || []).filter((b) => b.id !== id)
                );
              };

              // Expose helpers to rendering scope
              return { filteredLanguagesLoadOptions, addMoreLanguageRate, removeLanguageRate };
            })() && null}

            {(watch("translation_rates") || []).map((block, index) => {
              // const languageSelected = !!block.language;
              const languageSelected = Array.isArray(block.language) && block.language.length > 0;
              const selectedElsewhere = (watch("translation_rates") || [])
                .filter((_, idx) => idx !== index)
                .flatMap((b) =>
                  Array.isArray(b.language)
                    ? b.language.map((l) => l.value)
                    : []
                );

              return (
                <div key={block.id || index}>
                  <div className="row-primary align-items-center justify-content-between">
                    <div style={{ flex: 1 }}>
                      <div className="d-flex">
                      <h2 style={{marginTop : '0px'}}>{t('interpreter.selectLanguage')} *</h2>
                      <Controller
                        name={`translation_rates.${index}.language`}
                        control={control}
                        rules={{
                          validate: (value) =>
                            (Array.isArray(value) && value.length > 0) || t('interpreter.selectAtLeastOneLanguage'),
                        }}
                        render={({ field }) => (
                          <AsyncPaginate
                            menuPlacement="auto"
                            isMulti
                            styles={selectCustomStyles}
                            cacheUniqs={[selectedElsewhere.join(",")]}
                            value={field.value || []}
                            loadOptions={async (inputValue, loadedOptions, { page }) => {
                              const result = await dispatch(
                                fetchLanguages(
                                  page,
                                  { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue },
                                  true,
                                  true
                                )
                              );

                              return {
                                options: result?.data
                                  ?.filter((lang) => !selectedElsewhere.includes(lang.id))
                                  .map((language) => ({ value: language.id, label: language.name })),
                                hasMore: page !== result?.last_page,
                                additional: { page: page + 1 },
                              };
                            }}
                            isClearable
                            escapeClearsValue
                            onChange={(selected) => {
                              field.onChange(selected || []); // ✅ ab array save hoga, single object nahi
                            }}
                            additional={{ page: 1 }}
                          />
                        )}
                      />
                      </div>
                    </div>

                    {(watch("translation_rates") || []).length > 1 && (
                      <div>
                        <SubmitButton
                          buttonType="button"
                          className={"tomatoRed"}
                          btnText={t('common.delete')}
                          handleSubmit={() => {
                            const helpers = (function(){
                              const setVal = setValue;
                              return (id) => setVal(
                                "translation_rates",
                                (watch("translation_rates") || []).filter((b) => b.id !== id)
                              );
                            })();
                            helpers(block.id);
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* Validation message for language */}
                  {errors?.translation_rates?.[index]?.language && (
                    <div style={{ marginTop: 6 }}>
                      <ErrorMessage text={errors.translation_rates[index].language.message} />
                    </div>
                  )}

                  {/* Show church rates only when language selected and church_translation enabled */}
                  {languageSelected && translationChurchEnabled && (
                    <div className="rate_container_wrapper w-100">
                      <h2 className="fw-bold text-uppercase">{t('interpreter.churchRates')}</h2>
                      <div className="template_create rate_container">
                        <div className="row-primary align-items-end inner">
                          <h2 className="mb-3 my-0">{t('interpreter.rates')}</h2>

                          <div className="Inter_rate_row">
                            <h4>{t('invoiceEditForm.translation')}</h4>
                            <span className="static-unit-text">{t('interpreter.perWord')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.church.translation_rate`}
                                control={control}
                                rules={{ required: t('interpreter.translationRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.translationRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.church?.translation_rate?.message}
                            </div>
                          </div>

                          <div className="Inter_rate_row">
                            <h4>{t('interpreter.editing')}</h4>
                            <span className="static-unit-text">{t('interpreter.perWord')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.church.editing_rate`}
                                control={control}
                                rules={{ required: t('interpreter.editingRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.editingRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.church?.editing_rate?.message}
                            </div>
                          </div>

                          <div className="Inter_rate_row">
                            <h4>{t('interpreter.dtp')}</h4>
                            <span className="static-unit-text">{t('interpreter.perWork')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.church.dtp_rate`}
                                control={control}
                                rules={{ required: t('interpreter.dtpRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.dtpRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.church?.dtp_rate?.message}
                            </div>
                          </div>

                        </div>
                        <div className="row-primary align-items-end inner">
                          <h2 className="mb-3 my-0">{t('interpreter.rates')}</h2>

                          <div className="Inter_rate_row">
                            <h4>{t('interpreter.review')}</h4>
                            <span className="static-unit-text">{t('interpreter.perPage')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.church.review_rate`}
                                control={control}
                                rules={{ required: t('interpreter.reviewRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.reviewRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.church?.review_rate?.message}
                            </div>
                          </div>

                      <div className="Inter_rate_row">
                        <h4>{t('interpreter.audioRecording')}</h4>
                        <span className="static-unit-text">{t('interpreter.perWord')}</span>
                        <div className="create inter_wrapper">
                          <Controller
                            name={`translation_rates.${index}.church.audio_recording_rate`}
                            control={control}
                            rules={{ required: t('interpreter.audioRecordingRateRequired') }}
                            render={({ field }) => (
                              <input
                                className="input-in type_inp"
                                type="number"
                                min={0}
                                step={0.01}
                                placeholder={t('interpreter.audioRecordingRatePlaceholder')}
                                value={field.value ?? ""}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                            )}
                          />
                        </div>
                        <div className="error-message">
                          {errors?.translation_rates?.[index]?.church?.audio_recording_rate?.message}
                        </div>
                      </div>

                      <div className="Inter_rate_row">
                        <h4>{t('interpreter.transcription')}</h4>
                        <span className="static-unit-text">{t('interpreter.perAudioMinute')}</span>
                        <div className="create inter_wrapper">
                          <Controller
                            name={`translation_rates.${index}.church.transcription_rate`}
                            control={control}
                            rules={{ required: t('interpreter.transcriptionRateRequired') }}
                            render={({ field }) => (
                              <input
                                className="input-in type_inp"
                                type="number"
                                min={0}
                                step={0.01}
                                placeholder={t('interpreter.transcriptionRatePlaceholder')}
                                value={field.value ?? ""}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                            )}
                          />
                        </div>
                        <div className="error-message">
                          {errors?.translation_rates?.[index]?.church?.transcription_rate?.message}
                        </div>
                      </div>

                        </div>
                      </div>
                    </div>
                  )}

                  {/* Show normal rates only when language selected and normal_translation enabled */}
                  {languageSelected && translationNormalEnabled && (
                    <div className="rate_container_wrapper w-100 mt-3">
                      <h2 className="fw-bold text-uppercase">{t('interpreter.normalRates')}</h2>
                      <div className="template_create rate_container">
                        <div className="row-primary align-items-end inner">
                          <h2 className="mb-3 my-0">{t('interpreter.rates')}</h2>

                          <div className="Inter_rate_row">
                            <h4>{t('invoiceEditForm.translation')}</h4>
                            <span className="static-unit-text">{t('interpreter.perWord')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.normal.translation_rate`}
                                control={control}
                                rules={{ required: t('interpreter.translationRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.translationRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.normal?.translation_rate?.message}
                            </div>
                          </div>

                          <div className="Inter_rate_row">
                            <h4>{t('interpreter.editing')}</h4>
                            <span className="static-unit-text">{t('interpreter.perWord')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.normal.editing_rate`}
                                control={control}
                                rules={{ required: t('interpreter.editingRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.editingRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.normal?.editing_rate?.message}
                            </div>
                          </div>

                          <div className="Inter_rate_row">
                            <h4>{t('interpreter.dtp')}</h4>
                            <span className="static-unit-text">{t('interpreter.perWork')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.normal.dtp_rate`}
                                control={control}
                                rules={{ required: t('interpreter.dtpRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.dtpRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.normal?.dtp_rate?.message}
                            </div>
                          </div>

                        </div>
                        <div className="row-primary align-items-end inner">
                          <h2 className="mb-3 my-0">{t('interpreter.rates')}</h2>

                          <div className="Inter_rate_row">
                            <h4>{t('interpreter.review')}</h4>
                            <span className="static-unit-text">{t('interpreter.perPage')}</span>
                            <div className="create inter_wrapper">
                              <Controller
                                name={`translation_rates.${index}.normal.review_rate`}
                                control={control}
                                rules={{ required: t('interpreter.reviewRateRequired') }}
                                render={({ field }) => (
                                  <input
                                    className="input-in type_inp"
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    placeholder={t('interpreter.reviewRatePlaceholder')}
                                    value={field.value ?? ""}
                                    onChange={(e) => field.onChange(e.target.value)}
                                  />
                                )}
                              />
                            </div>
                            <div className="error-message">
                              {errors?.translation_rates?.[index]?.normal?.review_rate?.message}
                            </div>
                          </div>

                      <div className="Inter_rate_row">
                        <h4>{t('interpreter.audioRecording')}</h4>
                        <span className="static-unit-text">{t('interpreter.perWord')}</span>
                        <div className="create inter_wrapper">
                          <Controller
                            name={`translation_rates.${index}.normal.audio_recording_rate`}
                            control={control}
                            rules={{ required: t('interpreter.audioRecordingRateRequired') }}
                            render={({ field }) => (
                              <input
                                className="input-in type_inp"
                                type="number"
                                min={0}
                                step={0.01}
                                placeholder={t('interpreter.audioRecordingRatePlaceholder')}
                                value={field.value ?? ""}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                            )}
                          />
                        </div>
                        <div className="error-message">
                          {errors?.translation_rates?.[index]?.normal?.audio_recording_rate?.message}
                        </div>
                      </div>

                      <div className="Inter_rate_row">
                        <h4>{t('interpreter.transcription')}</h4>
                        <span className="static-unit-text">{t('interpreter.perAudioMinute')}</span>
                        <div className="create inter_wrapper">
                          <Controller
                            name={`translation_rates.${index}.normal.transcription_rate`}
                            control={control}
                            rules={{ required: t('interpreter.transcriptionRateRequired') }}
                            render={({ field }) => (
                              <input
                                className="input-in type_inp"
                                type="number"
                                min={0}
                                step={0.01}
                                placeholder={t('interpreter.transcriptionRatePlaceholder')}
                                value={field.value ?? ""}
                                onChange={(e) => field.onChange(e.target.value)}
                              />
                            )}
                          />
                        </div>
                        <div className="error-message">
                          {errors?.translation_rates?.[index]?.normal?.transcription_rate?.message}
                        </div>
                      </div>

                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            <div className="row-primary mt-3">
              <SubmitButton
                buttonType="button"
                className={"lightBlue"}
                btnText={t('interpreter.addMoreLanguageRates')}
                handleSubmit={() => {
                  setValue("translation_rates", [
                    ...(watch("translation_rates") || []),
                    {
                      id: Date.now(),
                      language: [],
                      church: {
                        translation_rate: "",
                        editing_rate: "",
                        dtp_rate: "",
                        review_rate: "",
                        audio_recording_rate: "",
                        transcription_rate: "",
                      },
                      normal: {
                        translation_rate: "",
                        editing_rate: "",
                        dtp_rate: "",
                        review_rate: "",
                        audio_recording_rate: "",
                        transcription_rate: "",
                      },
                    },
                  ]);
                }}
              />
            </div>
          </div>
        )}

        {/* {item?.id && ( */}
        <div
            className="row-primary"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              marginTop: 20,
              marginBottom: 30,
            }}
          >
          <VerificationDocuments
            item={item}
            canManageDocuments={() => checkPermission("Edit Interpreter")}
            control={control}
            errors={errors}
            submitMode="deferred"
          />
          </div>
        {/* )} */}

        {/* <div className="row-primary  template_switch" style={{ alignItems: "center" }}>
          <h2 className="mt-0">Is Translator</h2>
          <CustomSwitch
            labelText="active"
            checked={isTranslator === 1}
            handleChange={(checked) => setIsTranslator(checked ? 1 : 0)}
          />
        </div>

        {isTranslator === 1 && (
          <div
            className="row-primary  template_switch"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              marginTop: 20,
              marginBottom: 50,
            }}
          >
            <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <span style={{ color: "#6c7a89" }}>
                  Spanish translation rate*
                </span>
              </div>
              <div style={{ width: "36%" }}>
                <Controller
                  name="spanish_translation_rate"
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="normal_start_time"
                      required
                      placeholder="Spanish translation rate"
                      style={{ width: "100%", minHeight: 40, marginBottom: 0 }}
                      {...field}
                    />
                  )}
                />
                {errors?.spanish_translation_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage
                      text={errors?.spanish_translation_rate?.message}
                    />
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <span style={{ color: "#6c7a89" }}>Other translation rate*</span>
              </div>
              <div style={{ width: "36%" }}>
                <Controller
                  name="other_translation_rate"
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="normal_end_time"
                      required
                      placeholder="Other translation rate"
                      style={{ width: "100%", minHeight: 40, marginBottom: 0 }}
                      {...field}
                    />
                  )}
                />
                {errors?.other_translation_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage
                      text={errors?.other_translation_rate?.message}
                    />
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: 24,
                alignItems: "center",
                marginTop: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <span style={{ color: "#6c7a89" }}>
                  Spanish formatting rate*
                </span>
              </div>
              <div style={{ width: "36%" }}>
                <Controller
                  name="spanish_formatting_rate"
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="after_start_time"
                      required
                      placeholder="Spanish formatting rate"
                      style={{ width: "100%", minHeight: 40, marginBottom: 0 }}
                      {...field}
                    />
                  )}
                />
                {errors?.spanish_formatting_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage
                      text={errors?.spanish_formatting_rate?.message}
                    />
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <span style={{ color: "#6c7a89" }}>Other formatting rate*</span>
              </div>
              <div style={{ width: "36%" }}>
                <Controller
                  name="other_formatting_rate"
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="after_end_time"
                      required
                      placeholder="Other formatting rate"
                      style={{ width: "100%", minHeight: 40, marginBottom: 0 }}
                      {...field}
                    />
                  )}
                />
                {errors?.other_formatting_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage
                      text={errors?.other_formatting_rate?.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )} */}

        <div className="Form-footer footer_fullpage">
          <div className="row-primary m-0 align-items-center template_switch">
            {checkPermission("Status Interpreter") && (
              <>
                <h2 className="mt-0">{t('common.status')}</h2>
                <CustomSwitch
                  labelText="active"
                  checked={status == 1 ? true : false}
                  handleChange={(checked) => setStatus(checked ? 1 : 0)}
                />
              </>
            )}
          </div>

          <SubmitButton
            loader={loader}
            btnText={item?.id ? t('common.update') : t('common.create')}
          />
        </div>
      </form>
      {loader && <FullPageLoader />}
    </>
  );
};

export default AddInterpreter;
